<template>
    <div>
      <EmployeeDeniedLiquidations/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import EmployeeDeniedLiquidations from '@/components/EmployeeDeniedLiquidations.vue'
  
  export default {
    name: 'liquidation-approval-history-view',
    components: {
      EmployeeDeniedLiquidations
    }
  }
  </script>
  